

function Recepcion (){

    return(
        <div></div>
    )
};

export default Recepcion;